module.exports = __webpack_public_path__ + "img/cg_ruoyi_apple.76a4b380.jpg";